import axios from "axios";

const API_URL = process.env.VUE_APP_API_URL+'/account';

class AuthService {
  login(user) {
    return axios
      .post(API_URL + '/login', {
        username: user.username,
        email: user.email,
        password: user.password
      }).then(response => {
      if (response.data.token) {
        localStorage.setItem('user', JSON.stringify(response.data))
      }
    });

  }

  logout() {
    localStorage.removeItem('user');
  }

  register(user){
    return axios.post(API_URL + '/register', {
      username: user.username,
      email: user.email,
      password: user.password
    });
  }

  mailConfirm(userId, code){
    return axios.get(API_URL + `/confirmEmail?userId=${userId}&code=${code}`);
  }
}
export default new AuthService();
